<ng-container *ngIf="shouldRender"><ng-content></ng-content></ng-container>
